import ServicePoint from '../../../../model/WorkOrder/ServicePoint';

const fromDTO = ({
	carclubId,
	createDate,
	createUser,
	id,
	latitude,
	locationId,
	longitude,
	name,
	updateDate,
	updateUser,
}) => new ServicePoint({
	carclubCode: carclubId,
	code: id,
	createDate,
	createUser,
	lat: latitude,
	lng: longitude,
	locationCode: locationId,
	name: name,
	updateDate,
	updateUser,
});

const toDTO = ({
	...props
}) => ({
	...props,
});

const mapper = { fromDTO, toDTO };

export default mapper;